const ORIGEM = {
    MAN: { id: 'MAN', descricao: 'Manual' },
    B3: { id: 'B3', descricao: 'B3' },
    BC: { id: 'BC', descricao: 'BC' },
    CVM: { id: 'CVM', descricao: 'CVM' },
    TES: { id: 'TES', descricao: 'TES' },
    IBG: { id: 'IBG', descricao: 'IBGE' },
    ANB: { id: 'ANB', descricao: 'Anbima' },
    DEB: { id: 'DEB', descricao: 'Debentures' },
    FNP: { id: 'FNP', descricao: 'Finep' },
    FIP: { id: 'FNP', descricao: 'Fipe' },
    BND: { id: 'BND', descricao: 'BNDES' },
    FNE: { id: 'FNE', descricao: 'FUNDO.NET' },
    RF: { id: 'RF', descricao: 'Receita Federal' },
    UPL: { id: 'UPL', descricao: 'Upload' },
    SIS: { id: 'SIS', descricao: 'Sistema' },
    GOV: { id: 'GOV', descricao: 'gov.br' },
    USR: { id: 'USR', descricao: 'Usuário' }
};

module.exports = ORIGEM;

// 010 VISTA
// 012 EXERCÍCIO DE OPÇÕES DE COMPRA
// 013 EXERCÍCIO DE OPÇÕES DE VENDA
// 017 LEILÃO
// 020 FRACIONÁRIO
// 030 TERMO
// 050 FUTURO COM RETENÇÃO DE GANHO
// 060 FUTURO COM MOVIMENTAÇÃO CONTÍNUA 070 OPÇÕES DE COMPRA
// 080 OPÇÕES DE VENDA
